// =============================================================
// MISIONES 2026 — datos de la sección de progreso de Modo Juego
// =============================================================

import imgGatoCentinela from "../assets/gato-centinela-logo.png";
import imgHumana11 from "../assets/humana_11_logo.jfif";

//
// No hay backend: este archivo ES el panel de administración.
// Cuando alguien avise por WhatsApp que completó una misión, edita
// a mano el objeto correspondiente en MISSION_CATEGORIES:
//
//   - Si `firstClaim` está en null, esa persona/empresa es la primera:
//       firstClaim: {
//         name: "Nombre de quien lo logró",
//         message: "Cita textual opcional (o "" si no nos compartieron una)",
//         note: "Descripción breve de lo que hicieron, en nuestras palabras (opcional)",
//         link: "https://sitio-de-quien-logro.com", // opcional
//         date: "2026-03-01", // formato AAAA-MM-DD, o null si no aplica
//       },
//   - Si `firstClaim` ya tiene datos, la misión sigue activa: agrega a
//     quienes se sumen después dentro de `extraClaims` (solo se cuentan,
//     no llevan mensaje destacado):
//       extraClaims: [{ name: "...", date: "..." }, ...]
//
// El nivel, el % de la barra y el texto ("Nivel 2 · 3/5 para subir de
// nivel") se calculan solos a partir de cuántos hay en total
// (firstClaim + extraClaims) y de `claimsPerLevel` — NO edites level,
// levelLabel ni progressPct a mano, solo agrega gente a las listas de
// arriba. `claimsPerLevel` es cuántos logros se necesitan para subir
// un nivel; súbelo si quieres que cueste más trabajo llegar al
// siguiente nivel, bájalo si quieres que sea más fácil.
//
// Excepción: "desbloquear-juego" es un logro único e interno (no se
// repite), así que sí lleva level/levelLabel/progressPct fijos.
//
// Para empresas fundadoras y sus insignias, edita FOUNDING_COMPANIES
// más abajo.

export const MISSION_CATEGORIES = [
  {
    id: "desbloquear-juego",
    icon: "🚀",
    title: "Desbloquear el Juego",
    subtitle:
      "La misión que abrió todas las demás. La logramos nosotros al construir el catálogo de Modo Juego.",
    status: "completed", // 'completed' | 'open' | 'locked'
    level: 1,
    levelLabel: "Completada",
    progressPct: 100,
    firstClaim: {
      name: "Colaboratorio Carpintero",
      message:
        "Diseñamos y construimos el catálogo de Modo Juego. A partir de aquí, cada misión la completan ustedes.",
      date: null,
    },
    extraClaims: [],
    extraLabel: "apoyos",
    claimCta: null, // misión interna, no tiene botón de reclamo
  },
  {
    id: "compra-individual",
    icon: "🛒",
    title: "Compra Individual",
    subtitle:
      "Compra un juego de Modo Juego para ti, tu casa o tu evento. No importa el tamaño de la compra, desde el juego más chico hasta el más grande, todo suma nivel.",
    status: "open",
    claimsPerLevel: 5,
    firstClaim: {
      name: "Ani Melendrez",
      message: "",
      note: "Compró un Cornhole de madera para iniciar su propio negocio de renta de juegos.",
      link: null,
      date: null,
    },
    extraClaims: [],
    extraLabel: "compras más",
    claimCta: {
      text: "Hola, compré un juego de Modo Juego y quiero reclamar la misión Compra Individual 🎮",
    },
  },
  {
    id: "compra-paquete",
    icon: "📦",
    title: "Compra en Paquete",
    subtitle:
      "Cuando alguien arma su inventario con un paquete de 3 o más juegos esta misión sube de nivel.",
    status: "open",
    claimsPerLevel: 5,
    firstClaim: null,
    extraClaims: [],
    extraLabel: "paquetes más",
    claimCta: {
      text: "Hola, compré un paquete de juegos de Modo Juego y quiero reclamar la misión Compra en Paquete 📦",
    },
  },
  {
    id: "renta-evento",
    icon: "🎪",
    title: "Renta para Evento",
    subtitle:
      "Cada vez que alguien renta juegos de Modo Juego para su evento, esta misión sube de nivel.",
    status: "open",
    claimsPerLevel: 5,
    // No se sabe con certeza cuál de estas rentas fue cronológicamente la
    // primera — se dejó la Parroquia como destacada por ser la de mayor
    // escala. Si algún día se confirma el orden real, se puede reordenar.
    firstClaim: {
      name: "Parroquia Santa Rosa de Lima",
      message: "",
      note: "Rentó 16 juegos de Modo Juego para la kermesse de sus fiestas patronales.",
      link: null,
      date: null,
    },
    extraClaims: [
      {
        name: "Leo Bañuelos",
        note: "Rentó Jenga y Cornhole para su cumpleaños.",
        date: null,
      },
      {
        name: "Julieta Rojas",
        note: "Rentó juegos de Modo Juego para su cumpleaños.",
        date: null,
      },
      {
        name: "Manu Kasten",
        note: "Rentó Baseball, Cornhole, Dominó, Jenga y Lanzamiento de Aros para su cumpleaños.",
        date: null,
      },
    ],
    extraLabel: "eventos más",
    claimCta: {
      text: "Hola, renté juegos de Modo Juego para mi evento y quiero reclamar la misión Renta para Evento 🎪",
    },
  },
  {
    id: "colaboracion-empresarial",
    icon: "🤝",
    title: "Colaboración Empresarial",
    subtitle:
      "Cuando una empresa colabora con nosotros (evento, torneo, oficina), suma su logo a esta misión.",
    status: "open",
    claimsPerLevel: 5,
    firstClaim: {
      name: "Humana 11",
      // TODO: agregar una cita textual cuando Humana 11 nos comparta un mensaje.
      message: "",
      note: "Formación organizacional desde Jalisco a una gran red de empresas de la República Mexicana.",
      link: "https://www.humana11.com/",
      date: null,
    },
    extraClaims: [
      {
        name: "Lado Bemol",
        // TODO: agregar nota de en qué consistió la colaboración con el podcast.
        date: null,
      },
    ],
    extraLabel: "empresas más",
    claimCta: {
      text: "Hola, mi empresa quiere colaborar con Modo Juego y sumarse a esta misión 🤝",
    },
  },
  {
    id: "trotamundos",
    icon: "🌎",
    title: "Trotamundos",
    subtitle:
      "Cada vez que un juego de Modo Juego viaja a otra ciudad, esta misión sube de nivel.",
    status: "open",
    claimsPerLevel: 5,
    firstClaim: {
      name: "El Gato Centinela",
      message: "",
      note: "Ludoteca en Chiapas que ofrece los juegos mini de Modo Juego a sus visitantes.",
      link: "https://www.elgatocentinela.com.mx/",
      date: null,
    },
    extraClaims: [],
    extraLabel: "ciudades más",
    claimCta: {
      text: "Hola, compré un juego de Modo Juego para otra ciudad y quiero reclamar la misión Trotamundos 🌎",
    },
  },
  {
    id: "patrocinadores",
    icon: "⭐",
    title: "Patrocinadores",
    subtitle:
      "Patrocina un torneo o evento de Modo Juego, o apoya el proyecto en general — tu logo queda en el Salón de Empresas Fundadoras y recibes descuentos en tus próximas compras o rentas.",
    status: "open",
    claimsPerLevel: 5,
    firstClaim: null,
    // Cuando alguien patrocine: además de llenar firstClaim/extraClaims
    // aquí arriba, agrégalo también a FOUNDING_COMPANIES más abajo con
    // la insignia "patrocinador-oficial" para que su logo aparezca en
    // el Salón de Empresas Fundadoras.
    extraClaims: [],
    extraLabel: "patrocinadores más",
    claimCta: {
      text: "Hola, quiero patrocinar un torneo o evento de Modo Juego 🌟",
    },
  },
];

// Insignias disponibles para empresas fundadoras — agrega nuevas aquí y
// referéncialas por su id en `badges` dentro de FOUNDING_COMPANIES.
export const BADGE_DEFINITIONS = {
  fundadora: {
    emoji: "🏛️",
    label: "Empresa Fundadora",
    description: "De las primeras empresas en colaborar con Modo Juego.",
  },
  "oficina-gamer": {
    emoji: "🕹️",
    label: "Oficina Gamer",
    description: "Tiene un juego de Modo Juego instalado en sus oficinas.",
  },
  "campeon-torneo": {
    emoji: "🏆",
    label: "Campeón del Torneo",
    description: "Ganó un torneo oficial de Modo Juego.",
  },
  "oficina-nivel-10": {
    emoji: "🔟",
    label: "Oficina Nivel 10",
    description: "Ha colaborado con Modo Juego en 10 o más ocasiones.",
  },
  "cultura-juego": {
    emoji: "🎲",
    label: "Cultura de Juego",
    description:
      "Usa Modo Juego activamente para fortalecer la cultura de su equipo.",
  },
  "patrocinador-oficial": {
    emoji: "🌟",
    label: "Patrocinador Oficial",
    description:
      "Patrocinó un torneo, evento o al proyecto Modo Juego en general.",
  },
};

// Empresas con distintivo permanente. `logo` puede ser null mientras no
// tengamos el archivo (se muestra un placeholder con la inicial del nombre).
// `link` es opcional — si se agrega, el nombre de la empresa se vuelve un
// link a su página.
export const FOUNDING_COMPANIES = [
  {
    name: "Humana 11",
    logo: imgHumana11,
    link: "https://www.humana11.com/",
    badges: ["fundadora"],
  },
  {
    name: "El Gato Centinela",
    logo: imgGatoCentinela,
    link: "https://www.elgatocentinela.com.mx/",
    badges: ["fundadora", "cultura-juego"],
  },
  // Agrega más empresas fundadoras conforme colaboren, por ejemplo:
  // {
  //   name: "Nombre de la Empresa",
  //   logo: logoImportado, // import arriba del archivo del componente
  //   link: "https://sitio-de-la-empresa.com",
  //   badges: ["fundadora", "oficina-gamer"],
  // },
];

// -----------------------------------------------------------
// Fuera de alcance por ahora (fases futuras, no implementadas):
//   - Inicio de sesión para reclamar misiones desde la propia página.
//   - Huevos de pascua con descuentos/premios.
//   - Área de colaboraciones para propuestas de terceros.
//   - Automatización con NAS.com (no expone API para leer compras).
// -----------------------------------------------------------
